import { mapActions } from 'vuex'
import { ping } from '@/lib/api.js'
import DashboardCoreFooter from '@/views/components/core/Footer.vue'
import LanguageSelector from '@/views/components/core/LanguageSelector'
import ThemeSelector from '@/views/components/core/ThemeSelector'
import Logo from '@/views/components/sign/Logo'
import MaintenanceCard from '@/views/components/sign/MaintenanceCard'

export default {
  components: { DashboardCoreFooter, LanguageSelector, ThemeSelector, Logo, MaintenanceCard },
  data: () => ({
    loading: false,
    error: null,
    maintenance: false,
  }),
  async created() {
    try {
      await ping()
    } catch (error) {
      this.maintenance = true
    }
  },
  watch: {
    email() {
      this.error = null
    },
    password() {
      this.error = null
    },
    '$route.name': {
      handler() {
        this.error = null
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    ...mapActions({ login: 'LOGIN', setSignMessage: 'SET_SIGN_MESSAGE' }),
  },
}
